const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the user editor directive to manage edits on user objects
 */

app.directive('archiveContentFailedModal', [
  function () {
    return {
      restrict: 'E',
      scope: {
        onClose: '&',
        open: '=',
        attemptedContents: '<',
        results: '<',
      },
      template: require('../../../templates/directives/cms/archive-content-failed-modal.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.track = null;
          self.workflow = null;
          self.journeys = null;

          self.close = function () {
            $scope.onClose();
          };

          $scope.$watch('results', function (newVal) {
            if (newVal?.in_track?.length) {
              self.tracks = newVal.containingTracks;
            }
            if (newVal?.in_workflow?.length) {
              self.workflows = newVal.containingWorkflows;
            }
            if (newVal?.in_journey?.length) {
              self.journeys = newVal.containingJourneys;
            }
          });
        },
      ],
      controllerAs: 'ctrl',
    };
  },
]);
